import MediumUser from '../../../../../../types/MediumUser';
import {
    UserSelectionFilterState,
    UserSelectionState,
    UserSelectionStateType,
    UserSelectionStaticState,
    mkEmptyUserSelectionFilterState,
} from '../../../../components/UserSelection/types';

type RevieweeSelectionState = {
    selectedType: UserSelectionStateType;
    STATIC: UserSelectionStaticState;
    FILTER: UserSelectionFilterState;
};

export function getRevieweeSelection(users: MediumUser[], revieweeIds: string[]): RevieweeSelectionState {
    const revieweeIdSet = new Set(revieweeIds);
    const everyUserIsReviewee = users.every(u => revieweeIdSet.has(u.id));
    return {
        selectedType: everyUserIsReviewee || revieweeIds.length === 0 ? 'FILTER' : 'STATIC',
        STATIC: {
            type: 'STATIC',
            userIds: revieweeIds,
        },
        FILTER: mkEmptyUserSelectionFilterState(),
    };
}

export function getActiveRevieweeSelection(state: RevieweeSelectionState): UserSelectionState {
    return state[state.selectedType];
}
